/**
 * @type variable
 * @description Breakpoint values, same as in media-queriries.scss.
 */

export const breakpoint = {
  phone: {
    xs: 0,
    s: 321,
    m: 480,
  },
  tablet: 768,
  desktop: {
    xs: 1024,
    s: 1366,
    m: 1600,
    l: 1920,
    xl: 2560,
  },
}

/**
 * @type variable
 * @description Breakpoints for gsap.matchMedia().
 */

export const gsapBreakpoints = {
  desktop: `(min-width: ${breakpoint.desktop.s}px) `,
  smallDesktop: `(min-width: ${breakpoint.desktop.xs}px) and (max-width: ${breakpoint.desktop.s - 1}px)`,
  tablet: `(min-width: ${breakpoint.tablet}px) and (max-width: ${breakpoint.desktop.xs - 1}px)`,
  mobile: `(max-width: ${breakpoint.tablet - 1}px)`,
}
